"use strict";

(function () {
  'use strict';

  angular.module('lr.Notifier').directive('lrNotifier', [function () {
    return {
      restrict: 'E',
      template: ['<div ng-show="lrNotifier.data.display" class="lr-notifier alert alert-warning">', '  <div ng-click="lrNotifier.hide()" ng-hide="lrNotifier.data.toggle"  class="lr-notifier__close">', '    &times;', '  </div>', '  {{lrNotifier.data.activeContent}}', '  <div ng-if="lrNotifier.data.action">{{lrNotifier.data.action}}</div>', '</div>'].join(''),
      controller: function lrNotifierCtrl($scope, $lrNotifier) {
        var self = this;
        /**
         * watch $lrNotifier service for changes
         */

        $scope.$watch(function () {
          return $lrNotifier;
        }, function () {
          self.data = $lrNotifier;
        });

        this.hide = function () {
          $lrNotifier.hide();
        };
      },
      controllerAs: 'lrNotifier',
      bindToController: true
    };
  }]);
})();